var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraserArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    width: 32,
    height: 32,
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.97 30.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 9.38;\n        stroke-width: 1.88px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Eraser"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.95,22.28c-.36-.36-.36-.94,0-1.3l5.92-5.92c.36-.36.94-.36,1.3,0l8.16,8.16c.36.36.36.94,0,1.3l-5.29,5.29h2.2l14.31-14.31c.87-.87.87-2.29,0-3.16L21.05,3.84c-.87-.87-2.29-.87-3.16,0L1.62,20.11c-.87.87-.87,2.29,0,3.16l6.54,6.54h2.31l-7.52-7.52Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.16,
    y1: 29.81,
    x2: 32.03,
    y2: 29.81
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "8 0 0 0 0 8 8 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserArrow);
export default __webpack_public_path__ + "static/media/EraserArrow.4b42f645ff52d137ad4a9d029518dcc3.svg";
export { ForwardRef as ReactComponent };